export const LANDING_EXPERIMENT_KEY = "landing-beauty-product-v2";
export type LandingVariant = "control" | "guided";
const STORAGE_KEY = "ti_lp_beauty_product_v2";
let cached: LandingVariant | undefined;

/** Fresh 50/50 cohort; never mix assignments from the retired video redesign. */
export function getLandingVariant(): LandingVariant {
  if (import.meta.env.SSR) return "control";
  if (cached) return cached;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "control" || stored === "guided") return (cached = stored);
    cached = Math.random() < 0.5 ? "control" : "guided";
    window.localStorage.setItem(STORAGE_KEY, cached);
  } catch {
    // Preserve a random in-memory assignment when storage is unavailable.
    cached ??= Math.random() < 0.5 ? "control" : "guided";
  }
  return cached;
}

/** Capture context when the event occurs, including before deferred SDK init. */
export function getLandingTrackingContext(): Record<string, string> {
  if (import.meta.env.SSR || typeof window === "undefined") return {};
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  if (path !== "/" && path !== "/beauty") return {};
  const isPreview = path === "/beauty";
  const variant = isPreview ? "guided" : getLandingVariant();
  return {
    landingExperiment: LANDING_EXPERIMENT_KEY,
    landingVariant: variant,
    landingRevision: variant === "guided" ? "product-v2" : "original",
    landingMode: isPreview ? "preview" : "experiment",
    landingPage: path,
  };
}
